export default __webpack_public_path__ + "static/media/cssC.daec1c11.webp";